/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import ehs from '@/http/requests/ehs'
import axios from '../axios.js'
import notification from '@/http/requests/notification'
const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  updateUserRole({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', { userRole: payload.userRole })
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////
  toggleSidebar({ commit }, val) {
    commit('TOGGLE_SIDEBAR', val)
  },
  toggleModal({ commit }, val) {
    commit('TOGGLE_MODAL', val)
  },

  togglePdfViewer({ commit }, val) {
    commit('TOGGLE_PDF_VIEWER', val)
  },

  getNotifications({ commit }) {
    axios.get('notificacions/ehs').then(res => {
      const notifications = res.data.ehs
      const compliance = res.data.compliance
      const payroll = res.data.payroll
      const negative_expenses = res.data.negative_expenses
      compliance.forEach(element => {
        notifications.push(element)
      })
      payroll.forEach(element => {
        notifications.push(element)
      })
      negative_expenses.forEach(element => {
        notifications.push(element)
      })
      commit('SET_NOTIFICATIONS', notifications)
    })
  },

  getStatusEhsList({ commit }) {
    axios.get('ehs/status').then(res => {
      const statusEhs = res.data.status
      commit('SET_STATUS_EHS_SELECT', statusEhs)
    })
  },
  clearGlobalEhsFilter({ commit }) {
    commit('CLEAR_GLOBAL_FILTER_EHS')
  },
  setGlobalEhsFilter({ commit }, val) {
    commit('SET_GLOBAL_FILTER_EHS', val)
  },

  getStatusComplianceList({ commit }) {
    axios.get('compliance/status').then(res => {
      const statusCompliance = res.data.status
      commit('SET_STATUS_COMPLIANCE_SELECT', statusCompliance)
    })
  },
  clearGlobalComplianceFilter({ commit }) {
    commit('CLEAR_GLOBAL_FILTER_COMPLIANCE')
  },
  setGlobalComplianceFilter({ commit }, val) {
    commit('SET_GLOBAL_FILTER_COMPLIANCE', val)
  },
  setGlobalExpensesFilter({ commit }, val) {
    commit('SET_GLOBAL_FILTER_EXPENSE', val)
  },
  setCurrentExchangeRate({ commit }, val) {
    commit('SET_CURRENT_EXCHANGE_RATE', val)
  },
  getNotificationComment({ commit }) {
    return notification.expenses().then(res => {
      commit('SET_NOTIFICATION_COMMENT', res.data.expenses)
    })
  },
  setFilter({ commit }, val) {
    commit('SET_FILTER', val)
  },
  togglePdfReader({ commit }, val) {
    commit('TOGGLE_PDF_READER', val)
  },
  setPopup({ commit }, val) {
    commit('SET_POPUP', val)
  },

}

export default actions
